import { getCampaignTitle } from '@esentai/core/features/campaigns/selectors';
import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import Suggestion from './component';
import styles from './styles';

const mapStateToProps = (state, { itemId }) => ({
  title: getCampaignTitle(state, itemId),
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(Suggestion);
